<template>
  <div class="tan px_kcadd">
    <div class="px_add_con">
      <div class="h370 rdiv">
        <h3 v-if="title">{{title}}</h3>
        <h3 v-else>选择上级菜单</h3>
        <a href="javascript:void(0);" class="close" @click="$emit('close')"></a>
        <div class="h295">
          <!--v-tree ref='tree' :data='data' :halfcheck='true' :selectAlone="true" :searchable="true" v-if="data" /-->
          <treeselect v-if="data"
            :alwaysOpen="true"
            :options="tree"
            :searchable="true"
            :flatten-search-results="true"
            valueFormat="object"
            :show-count="true"
            placeholder="请选择"
            required
            v-model="selectedValues"
          >
          </treeselect>
          <div style="text-align: center;" v-if="!data">
            <img src="@/assets/images/none_data.jpg">
            <div>暂无部门,请添加</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="w240 wrap">
        <input name="" type="button" value="确定" class="all_btn" @click="getCheckedNodes"/>
        <input name="" type="button" value="取消" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Bus from '@/utils/bus'
  import clonedeep from 'lodash.clonedeep'
  import utils from '@/utils'
  import Treeselect from '@riophae/vue-treeselect'
  import '@/assets/css/treeselect.css'
  /* import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  import { VTree, VSelectTree } from 'vue-tree-halower'
  Vue.use(VTree)
  Vue.use(VSelectTree) */
    export default {
      name: "treemenu",
      components: { Treeselect },
      created () {
        this.tree = this.dealTree(clonedeep(this.data))
        if (!this.selected) {
          this.selectedValues = {
            id: '0',
            label: '无'
          }
        } else {
          if (this.selected && this.selected.id) {
            this.selectedValues = clonedeep(this.selected)
          } else {
            this.selectedValues = {
              id: '0',
              label: '无'
            }
          }
        }
      },
      data () {
          return {
            searchword: '',
            selectedValues: {
              id: '0',
              label: '无'
            },
            tree: []
          }
      },
      methods: {
        dealTree (arr) {
          var dealArr = []
          if (arr && arr.length > 0) {
            for (var i = 0; i< arr.length; i++) {
              var temp = clonedeep(arr[i])
              temp.label = temp.name
              if (arr[i].children && arr[i].children.length > 0) {
                temp.children = this.dealTree(arr[i].children)
              }
              dealArr.push(temp)
            }
          }
          return dealArr
        },
        getCheckedNodes () {
          /* if (this.$refs.tree) {
            let nodes = this.$refs.tree.getSelectedNodes()
            console.log(nodes)
            if (this.yes) {
              this.yes(nodes)
            }
            Bus.$emit('selected-parent-menu', nodes)
            this.$emit('close')
          } */
          if (this.yes) {
            this.yes([this.selectedValues])
          }
          Bus.$emit('selected-parent-menu', [this.selectedValues])
          this.$emit('close')
        }
      },
      props: ['data', 'title', 'yes', 'selected']
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/sys/menu/treemenu.vue